(function(){
var container=document.getElementById('faq-sections');
if(!container)return;

var D=[].map.call(container.querySelectorAll('.faq-section'),function(sec){
var ic=sec.querySelector('.faq-section-icon');
return{slug:sec.id.replace(/^faq-/,''),cat:sec.querySelector('.faq-section-head h2').textContent,icon:ic.innerHTML,bg:ic.style.background,color:ic.style.color,qs:[].map.call(sec.querySelectorAll('.faq-item'),function(it){
return{q:it.querySelector('.faq-q-text').textContent,a:it.querySelector('.faq-a-inner').innerHTML};
})};
});

var activeCat="all",searchTerm="";

function esc(s){var d=document.createElement('div');d.textContent=s;return d.innerHTML;}
function highlight(text,term){if(!term)return text;var re=new RegExp('('+term.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+')','gi');return text.replace(re,'<span class="faq-highlight">$1</span>');}
function stripHtml(s){var d=document.createElement('div');d.innerHTML=s;return d.textContent||'';}

function setActive(){
document.getElementById('faq-nav').querySelectorAll('.faq-pill').forEach(function(p){p.classList.toggle('active',p.dataset.cat===activeCat);});
}

function initNav(){
var nav=document.getElementById('faq-nav');if(!nav)return;
nav.addEventListener('click',function(e){var btn=e.target.closest('.faq-pill');if(!btn)return;activeCat=btn.dataset.cat;setActive();render();});
}

function initPopular(){
var grid=document.getElementById('faq-quick-grid');if(!grid)return;
grid.addEventListener('click',function(e){var card=e.target.closest('.faq-quick-card');if(!card){return;}e.preventDefault();activeCat=card.dataset.cat;setActive();render();var idx=parseInt(card.dataset.idx);setTimeout(function(){var items=document.querySelectorAll('#faq-'+card.dataset.cat+' .faq-item');if(items[idx]){items[idx].scrollIntoView({behavior:'smooth',block:'center'});items[idx].querySelector('.faq-q').click();}},100);});
}

function render(){
var empty=document.getElementById('faq-empty');
var toc=document.getElementById('faq-toc');
var pop=document.getElementById('faq-popular');
var term=searchTerm.toLowerCase().trim();
var h='',totalVisible=0;

D.forEach(function(cat){
if(activeCat!=='all'&&cat.slug!==activeCat)return;
var visQs=cat.qs.filter(function(q){
if(!term)return true;
return q.q.toLowerCase().indexOf(term)!==-1||stripHtml(q.a).toLowerCase().indexOf(term)!==-1;
});
if(!visQs.length)return;
totalVisible+=visQs.length;

h+='<section class="faq-section" id="faq-'+cat.slug+'">';
h+='<div class="faq-section-head"><div class="faq-section-icon" style="background:'+cat.bg+';color:'+cat.color+'">'+cat.icon+'</div><h2>'+esc(cat.cat)+'</h2><span class="faq-section-count">'+visQs.length+' question'+(visQs.length!==1?'s':'')+'</span></div>';

visQs.forEach(function(q){
var qText=term?highlight(esc(q.q),term):esc(q.q);
var aText=term?highlight(q.a,term):q.a;
h+='<div class="faq-item">';
h+='<button class="faq-q" aria-expanded="false"><div class="faq-q-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></div><span class="faq-q-text">'+qText+'</span></button>';
h+='<div class="faq-a"><div class="faq-a-inner">'+aText+'</div></div>';
h+='</div>';
});
h+='</section>';
});

container.innerHTML=h;
empty.style.display=totalVisible?'none':'block';
toc.style.display=term||activeCat!=='all'?'none':'';
pop.style.display=term||activeCat!=='all'?'none':'';
}

container.addEventListener('click',function(e){
var btn=e.target.closest('.faq-q');if(!btn)return;
var item=btn.closest('.faq-item');
var wasOpen=item.classList.contains('open');
container.querySelectorAll('.faq-item.open').forEach(function(el){el.classList.remove('open');el.querySelector('.faq-q').setAttribute('aria-expanded','false');});
if(!wasOpen){item.classList.add('open');btn.setAttribute('aria-expanded','true');}
});

function initSearch(){
var input=document.getElementById('faq-search');
var clear=document.getElementById('faq-clear');
if(!input)return;
var timer;
input.addEventListener('input',function(){
clearTimeout(timer);
timer=setTimeout(function(){
searchTerm=input.value;
clear.classList.toggle('show',!!searchTerm);
render();
},200);
});
clear.addEventListener('click',function(){input.value='';searchTerm='';clear.classList.remove('show');render();input.focus();});
}

function injectSitelinksSearch(){
var schema={"@context":"https://schema.org","@type":"WebPage","name":"DTFSheet FAQ - Frequently Asked Questions","description":"Find answers to 73+ questions about DTF printing, ordering, shipping, heat pressing, artwork guidelines, pricing, and returns at DTFSheet.com","url":"https://dtfsheet.com/pages/dtfsheet-faq","isPartOf":{"@type":"WebSite","name":"DTFSheet","url":"https://dtfsheet.com"},"breadcrumb":{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://dtfsheet.com/"},{"@type":"ListItem","position":2,"name":"FAQ","item":"https://dtfsheet.com/pages/dtfsheet-faq"}]},"speakable":{"@type":"SpeakableSpecification","cssSelector":[".faq-q-text",".faq-a-inner"]}};
var script=document.createElement('script');
script.type='application/ld+json';
script.textContent=JSON.stringify(schema);
document.head.appendChild(script);
}

initNav();initPopular();initSearch();injectSitelinksSearch();
document.title='DTF Printing FAQ - 73+ Answers About Custom DTF Transfers | DTFSheet';
})();
